import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { SectionCard, SectionHeader, SectionTitle, CloseButton, TasksList, TaskItem, TaskText, StyledCollapse } from './styles';
import { DailyTasksSectionProps } from './types';

const { Panel } = StyledCollapse;

const DailyTasksSection: React.FC<DailyTasksSectionProps> = ({
  dailyTasks,
  isOpen,
  onClose,
}) => {
  return (
    <StyledCollapse activeKey={isOpen ? ['dailyTasks'] : []} ghost expandIcon={() => null}>
      <Panel key="dailyTasks" header={null}>
        <SectionCard>
          <SectionHeader>
            <SectionTitle level={4}>Daily Tasks</SectionTitle>
            <CloseButton
              type="text"
              icon={<CloseOutlined />}
              onClick={onClose}
              aria-label="Close"
            />
          </SectionHeader>
          <TasksList>
            {dailyTasks.map((task, index) => (
              <TaskItem key={index}>
                <TaskText>{task.description}</TaskText>
              </TaskItem>
            ))}
          </TasksList>
        </SectionCard>
      </Panel>
    </StyledCollapse>
  );
};

export default DailyTasksSection;
